import theme, { createLLMTypography } from "../../../../../Constants/theme";

export const botTypeContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  overflowY: "hidden",
};

export const reactFlowWrapperStyles = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "100%",
};

export const fileNameContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  color: "var(--bgLight)",
  gap: "8px",
};

export const fileNameContainerInput = {
  padding: "8px 3px",
  border: "none",
  outline: "none",
  borderRadius: "5px",
};

export const fileNameIconsInputs = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  color: "var(--bgLight)",
  whiteSpace: "nowrap",
};

export const createNode = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "var(--colorPrimary)",
  padding: "10px",
  width: "100%",
  zIndex: 1,
  "@media screen and (max-width: 700px)": {
    display: "none",
  },
};

export const createNodeInputButton = {
  backgroundColor: "#726DFF",
  color: "white",
  width: "100px",
  height: "40px",
  cursor: "pointer",
  fontSize: "1.3rem",
  border: "none",
  borderRadius: "5px",
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)",
  marginRight: "20px",
  "&:hover": {
    backgroundColor: "#8380d4df",
    transition: "0.02s ease-in-out",
  },
};

export const topNavNode = {
  backgroundColor: "#1e2732",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 15px",
  width: "100%",
  minWidth: "200px",
  color: "white",
  borderRadius: "10px",
  borderBottomLeftRadius: "0px",
  borderBottomRightRadius: "0px",
  borderBottom: `2px solid ${theme.border.light}`,
};

export const topNavNodeText = {
  fontSize: "18px",
};

export const childNodeNavText = {
  fontSize: "16px",
};

export const topNavNodeHidden = {
  backgroundColor: "#1e2732",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px",
  width: "100%",
  minWidth: "200px",
  color: "white",
  borderRadius: "10px",
  borderBottomLeftRadius: "0px",
  borderBottomRightRadius: "0px",
  borderBottom: `2px solid ${theme.border.light}`,
};

export const checkNodeTopNavNode = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "250px",
  maxWidth: "250px",
  color: "white",
  border: "1px solid var(--colorBorder)",
  height: "auto",
};

export const queryloopParamsContainer = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  gap: 1,
  width: "580px",
  alignItems: "flex-start",

  borderRadius: "10px",
  border: `1px solid ${theme.border.light}`,
  m: 2,
  mt: 2.5,
};

export const advancedOptionStyles = {
  display: "flex",
  flexDirection: "row",
  width: "95%",
  justifyContent: "flex-end",
};

export const queryloopNodeStyles = {
  display: "flex",
  flexDirection: "column",
  width: "auto",
  height: "auto",
  border: "none",
  background: theme.main.applicationBackground,
  borderRadius: "10px",
};

export const queryloopNodeMinifiedStyles = {
  display: "flex",
  flexDirection: "column",
  width: "auto",
  height: "auto",
  border: "none",
  backgroundColor: theme.main.backgroundBlue,
  boxShadow: "0px 5px 30px rgba(0, 0, 0, 0.3)",
  paddingBottom: "20px",
};

export const queryloopNode = {
  display: "flex",
  flexDirection: "column",
  width: "1100px",
  height: "auto",
  border: "none",
  backgroundColor: "rgb(239, 242, 255)",
  boxShadow: "0px 5px 30px rgba(0, 0, 0, 0.3)",
};

export const queryloopNodeMinified = {
  display: "flex",
  flexDirection: "column",
  width: "600px",
  height: "auto",
  border: "none",
  backgroundColor: "rgb(239, 242, 255)",
  boxShadow: "0px 5px 30px rgba(0, 0, 0, 0.3)",
  paddingBottom: "20px",
};

export const tableContainerRag = {
  width: "100%",
  marginTop: "10px",
  mb: 2,
  border: `1px solid ${theme.border.light}`,
  borderRadius: "10px",
};

export const problemStatementNode = {
  display: "flex",
  flexDirection: "column",
  width: "350px",
  height: "auto",
  // backgroundColor: theme.backgroundColors.dark.secondary,
  border: `1px solid ${theme.border.light}`,
  borderRadius: "10px",
};

export const problemStatementNodeInput = {
  px: 2,
  py: 2,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export const tableNodeInfo = {
  backgroundColor: "#1e2732",
  color: "white",
  padding: "10px",
  fontSize: "0.8rem",
};

export const promptRadio = {
  padding: "2px 7px",
  backgroundColor: "white",
};

export const nodeStyles = {
  width: "auto",
  height: "auto",
  color: "white",
  backgroundColor: `${theme.main.applicationBackground}`,
  border: `1px solid ${theme.border.light}`,
  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "rgba(68, 61, 255, 0.5) transparent", // For Firefox
  "&::-webkit-scrollbar": {
    width: "10px", // Adjust width
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(68, 61, 255, 0.7)",
    borderRadius: "10px", // Rounded scrollbar
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent", // Hide track background
  },
};

export const datasetNodeStyles = {
  display: "flex",
  flexDirection: "column",
  // width: "500px",
  height: "auto",
  borderRadius: "10px",
  // Firefox
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(68, 61, 255, 0.5) transparent",
  // WebKit
  "&::-webkit-scrollbar": {
    width: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(68, 61, 255, 0.7)",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
};

export const nodeInputStyles = {
  "&:disabled": {
    cursor: "not-allowed",
  },
  fontSize: createLLMTypography.fontSizes.sectionTitle,
};

export const nodeInputStylesDisabled = {
  "&:disabled": {
    cursor: "not-allowed",
  },
};

export const fileNodeInputStyles = {
  px: "20px",
  pb: 2,
  display: "flex",
  flexDirection: "row",
  width: "500px",
};

export const tableNodeStyles = {
  "&::-webkit-scrollbar": {
    width: "4px",
    height: "4px",
    backgroundColor: "#050505",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "gray",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "var(--buttonBackground)",
  },
};

export const goldenReponseNodeStyles = {
  height: "auto",
  width: "350px",
  borderRadius: "10px",
};

export const goldenResponsesButtonStyles = {
  padding: "2px 7px",
  display: "flex",
  flexDirection: "column",
  width: "350px",
  height: "auto",
};

export const goldenResponsesViewStyles = {
  padding: "2px 7px",
};

export const selectCustomstyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
  flex: 1,
  color: "white",
};

export const deleteDatasetStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",
  padding: "15px",
};
export const deleteDatasetButtonStyles = {
  backgroundColor: "var(--colorDanger)",
  color: "var(--bgLight)",
  border: "none",
  cursor: "pointer",
  padding: "3px",
  borderRadius: "5px",
  "&:hover": {
    backgroundColor: "var(--colorDangerHover)",
    color: "var(--bgLight)",
  },
};

export const accordionStyles = {
  padding: "2px 7px",
};

export const accordionHeaderStyles = {
  backgroundColor: "#726DFF",
  color: "white",
  cursor: "pointer",
  fontSize: "1rem",
  border: "none",
  borderRadius: "5px",
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)",
  marginBottom: "1rem",
};

export const viewDatasetsStyles = {
  marginTop: "-20px",
  width: "100%",
};

export const inputsFileFolderStyles = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "5px",
  color: "white",
};

export const inputsFileFolderCustomStyles = {
  display: "flex",
  justifySelf: "flex-start",
  flexDirection: "row",
  width: "50%",
  alignItems: "center",
  gap: 2,
};
